<template>
  <v-card class="card-rounded" elevation="1">
    <v-card-title>
      <h1  class="secondary--text">Cursos</h1>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list two-line subheader dense>
        <v-subheader>Folders</v-subheader>

        <v-list-tile
          avatar
          @click=""
        >
          <v-list-tile-avatar>
            <v-icon >folder</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>Curso 1</v-list-tile-title>
            <v-list-tile-sub-title>Apresentação de novo curso</v-list-tile-sub-title>
          </v-list-tile-content>

        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'image',
  props: ['image']
}
</script>

<style>
.image {
  flex-wrap: wrap;
  padding: 15px;
}

.image-inner {
  display: flex;
  align-items: center;
  width: 8cm;
  height: 4cm;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
}
.image-wrap .image {
  width: 100%;
  height: 100%;
}
</style>
